"use client";

import { Button } from "@/components/ui/button";
import { Slider } from "@/components/ui/slider";
import { useScopedI18n } from "@/messages/client";
import { Column } from "@tanstack/react-table";
import { useState } from "react";

export default function Range<T>({ column }: { column: Column<T, unknown> }) {
  const t = useScopedI18n("选型器");

  const min = Number(column.getFacetedMinMaxValues()?.[0]);

  const max = Number(column.getFacetedMinMaxValues()?.[1]);

  const columnFilterValue = column.getFilterValue() as [number, number];

  const [sliderVal, setSliderVal] = useState<any[]>(
    columnFilterValue ?? [min, max]
  );

  const [value, setValue] = useState<any[]>(columnFilterValue);

  return (
    <div className="bg-[#f8f8f8] md:px-6 px-4 md:pb-4 pb-2">
      <Slider
        className="py-5"
        value={sliderVal}
        min={min}
        max={max}
        onValueChange={(e) => {
          setSliderVal(e);
          setValue(e);
          column.setFilterValue(e);
        }}
      />

      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <span>≥</span>
          <input
            value={value?.[0] ?? min}
            className="w-16 border-b border-[#ccc] bg-white p-1 text-right text-xs outline-none transition-colors focus:border-black"
            onChange={(e) => {
              setValue((old: number[]) => [e.target.value, old?.[1] ?? max]);
            }}
            onBlur={(e) => {
              const inputValue = Number(e.target.value);

              let sliderValue = [value?.[0] ?? min, value?.[1] ?? max];

              if (isNaN(inputValue)) {
                setValue(sliderValue);
              } else {
                if (inputValue > max) {
                  sliderValue = [max, value?.[1] ?? max];
                } else if (inputValue < min) {
                  sliderValue = [min, value?.[1] ?? max];
                } else if (inputValue > value?.[1]) {
                  sliderValue = [value?.[1], value?.[1] ?? max];
                } else {
                  sliderValue = [inputValue, value?.[1] ?? max];
                }

                setValue(sliderValue);
                setSliderVal(sliderValue);
                column.setFilterValue(sliderValue);
              }
            }}
          />
        </div>
        <div className="flex items-center">
          <span>≤</span>
          <input
            value={value?.[1] ?? max}
            className="w-16 border-b border-[#ccc] bg-white p-1 text-right text-xs outline-none transition-colors focus:border-black"
            onChange={(e) => {
              setValue((old: number[]) => [old?.[0] ?? min, e.target.value]);
            }}
            onBlur={(e) => {
              const inputValue = Number(e.target.value);

              let sliderValue = [value?.[0] ?? min, value?.[1] ?? max];

              if (isNaN(inputValue)) {
                setValue(sliderValue);
              } else {
                if (inputValue > max) {
                  sliderValue = [value?.[0] ?? min, max];
                } else if (inputValue < min) {
                  sliderValue = [value?.[0] ?? min, min];
                } else if (inputValue < value?.[0]) {
                  sliderValue = [value?.[0], value?.[0]];
                } else {
                  sliderValue = [value?.[0] ?? min, inputValue];
                }

                setValue(sliderValue);
                setSliderVal(sliderValue);
                column.setFilterValue(sliderValue);
              }
            }}
          />
        </div>
      </div>
      <div className="pt-4">
        <Button
          className="h-auto p-0 text-sm font-normal text-primary hover:bg-transparent"
          variant="ghost"
          onClick={() => {
            column.setFilterValue(undefined);
            setValue([min, max]);
            setSliderVal([min, max]);
          }}>
          {t("复位")}
        </Button>
      </div>
    </div>
  );
}
